import { render } from "./ButtonTimeOut.vue?vue&type=template&id=3ee38d6c"
import script from "./ButtonTimeOut.vue?vue&type=script&lang=js"
export * from "./ButtonTimeOut.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__